import { SHOW_MEMBERS_AREA_PAGE } from '../types/authentication';

export const showMembersArea = (isOpen) => {
  return {
    type: SHOW_MEMBERS_AREA_PAGE,
    payload: isOpen
  };
};
